export default {
  name: "BeneficiaryRegister",

  data: () => ({
      activeTab: "All",
      search: "",

      tabs: ["All", "Active", "Inactive", "Pending"],

      stats: [
        { label: "Total Beneficiaries", value: 7 },
        { label: "Active", value: 5, colorClass: "text-emerald-500" },
        { label: "Pending KYC", value: 3, colorClass: "text-orange-400" },
        { label: "Fully Verified", value: 3 }
      ],

      beneficiaries: [
        { id: 1, initials: "SN", name: "Sipho Ndlovu", idNumber: "****1234", startDate: "2023-06-10", status: "Active", kyc: "Pending", allocation: 1.2, distributed: 45320 },
        { id: 2, initials: "TN", name: "Thandi Ngcobo", idNumber: "****5678", startDate: "2023-01-15", status: "Active", kyc: "Approved", allocation: 1.5, distributed: 67500 },
        { id: 3, initials: "BZ", name: "Bongani Zulu", idNumber: "****9012", startDate: "2023-03-20", status: "Active", kyc: "Approved", allocation: 1.0, distributed: 38200 },
        { id: 4, initials: "NK", name: "Nomsa Khumalo", idNumber: "****3456", startDate: "2024-02-01", status: "Active", kyc: "Pending", allocation: 0.8, distributed: 12500 },
        { id: 5, initials: "MS", name: "Mandla Sithole", idNumber: "****7890", startDate: "2023-09-15", status: "Inactive", kyc: "Rejected", allocation: 1.0, distributed: 25000 },
        { id: 6, initials: "ZM", name: "Zanele Mbeki", idNumber: "****2345", startDate: "2023-07-01", status: "Active", kyc: "Approved", allocation: 1.3, distributed: 52100 }
      ]
  }),

  computed: {
    filteredBeneficiaries() {
      let list = this.beneficiaries;

      // Filter by tab
      if (this.activeTab !== "All") {
        list = list.filter(
          b =>
            b.status === this.activeTab ||
            b.kyc === this.activeTab
        );
      }

      // Filter by search
      if (this.search) {
        const searchLower = this.search.toLowerCase();
        list = list.filter(b =>
          b.name.toLowerCase().includes(searchLower)
        );
      }

      return list;
    }
  },

  methods: {
    formatCurrency(value) {
      return value.toLocaleString();
    }
  }
};